export const arrayDiffIdCompare = <T extends { id: unknown }>(a: T, b: T) => a.id === b.id;

export const arrayDiff = <T>(
  arr1: T[],
  arr2: T[],
  compare: (a: T, b: T) => boolean = (a, b) => a === b,
) => arr1.filter(element => !arr2.some((value) => {
  return compare(value, element);
}));
